<template></template>

<script>
import * as type from '@/utvStore/store/mutation-types';

export default {
  name: "topStarManage",
  created() {
    this.$store.dispatch(type.GET_TOP_STAR_LIST);
  }
}
</script>




// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/TopStarManage.vue